export default "__VITE_ASSET__nLd_Fn30__"